import React from 'react';

const LinkedInPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fab fa-linkedin-in"></i>
          LinkedIn - Marco De Marco
        </h1>
        <p>Connect with me professionally on LinkedIn for business and career updates.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="social-content">
            <p className="welcome-text">
              LinkedIn is where I maintain my professional presence, sharing
              career updates, business insights, and connecting with colleagues
              and industry professionals.
            </p>

            {/* LinkedIn Profile Embed */}
            <div className="linkedin-embed">
              <h3>Professional Profile</h3>
              <div className="social-embed-container">
                <div className="linkedin-badge-container">
                  <div 
                    className="badge-base LI-profile-badge" 
                    data-locale="en_US" 
                    data-size="large" 
                    data-theme="light" 
                    data-type="VERTICAL" 
                    data-vanity="marcodemarco" 
                    data-version="v1"
                  >
                    <a 
                      className="badge-base__link LI-simple-link" 
                      href="https://www.linkedin.com/in/marcodemarco?trk=profile-badge"
                    >
                      Marco De Marco
                    </a>
                  </div>
                </div>
                <script src="https://platform.linkedin.com/badges/js/profile.js" async defer type="text/javascript"></script>
              </div>
            </div>

            {/* What to Expect */}
            <div className="content-preview">
              <h3>What You'll Find on My LinkedIn</h3>
              <div className="social-features">
                <div className="feature-item">
                  <i className="fas fa-briefcase"></i>
                  <h4>Professional Updates</h4>
                  <p>Career milestones, work achievements, and professional growth</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-users"></i>
                  <h4>Networking</h4>
                  <p>Connecting with colleagues, industry professionals, and business contacts</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-lightbulb"></i>
                  <h4>Industry Insights</h4>
                  <p>Thoughts on business trends, leadership, and professional development</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-graduation-cap"></i>
                  <h4>Learning & Growth</h4>
                  <p>Continuous learning experiences and professional skill development</p>
                </div>
              </div>
            </div>

            {/* Professional Background */}
            <div className="professional-summary">
              <h3>Professional Background</h3>
              <p>
                With years of experience in my field, I bring a combination of
                technical expertise, leadership skills, and a commitment to excellence.
                My LinkedIn profile showcases my professional journey, accomplishments,
                and the values that drive my work.
              </p>
              
              <div className="professional-values">
                <h4>Core Professional Values:</h4>
                <ul>
                  <li>Integrity and ethical business practices</li>
                  <li>Continuous learning and adaptation</li>
                  <li>Building strong professional relationships</li>
                  <li>Contributing to team success and organizational growth</li>
                  <li>Balancing professional excellence with family values</li>
                </ul>
              </div>
            </div>

            {/* Direct Link */}
            <div className="social-link-section">
              <h3>Connect on LinkedIn</h3>
              <a 
                href="https://www.linkedin.com/in/marcodemarco/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-platform-link linkedin-link"
              >
                <i className="fab fa-linkedin-in"></i>
                Connect on LinkedIn
              </a>
              <p className="link-description">
                Click above to view my full LinkedIn profile and send a connection request.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkedInPage;